export default __webpack_public_path__ + "static/egc-logo-2021-3df3e56e63b079d7b54868104c1f0299.svg";